/* Diskré parallakse og innglidande element ved scrolling */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;

  function init() {
    /* 1. Parallakse i toppfelta */
    var layers = [];
    function add(sel, rate, fade) {
      document.querySelectorAll(sel).forEach(function (el) {
        var box = el.closest('.sf-hero, .sf-coll');
        if (box) layers.push({ el: el, box: box, rate: rate, fade: fade });
      });
    }
    add('.sf-hero__bg', 0.28, false);
    add('.sf-hero .sf-stardust', 0.14, false);
    add('.sf-hero__inner', -0.1, true);
    add('.sf-coll__photo', 0.22, false);
    add('.sf-coll__inner', -0.06, true);

    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      for (var i = 0; i < layers.length; i++) {
        var l = layers[i];
        var r = l.box.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) continue;
        var past = Math.max(0, -r.top);
        var y = past * l.rate;
        l.el.style.translate = '0 ' + (-y * -1).toFixed(1) + 'px';
        if (l.fade) {
          var p = Math.min(1, past / (r.height * 0.9));
          l.el.style.opacity = (1 - p * 0.55).toFixed(3);
        }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    if (layers.length) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    /* 2. Kort og blokker glir mjukt inn */
    if (!('IntersectionObserver' in window)) return;
    var sel = '.sf-head, .sf-card, .sf-zip, .sf-about > *, .sf-fact, .sf-empty, .sf-foot__news, .product-grid__item, .product-card';
    var items = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (el) {
      if (el.closest('.sf-hero, .sf-coll, header, .menu-drawer, cart-drawer-component, .cart-drawer')) return false;
      var r = el.getBoundingClientRect();
      return r.top > window.innerHeight * 0.92; /* ikkje rør det som alt er synleg */
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sf-rv--in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) {
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--sf-rv-d', (Math.min(sib, 5) * 0.07).toFixed(2) + 's');
      el.classList.add('sf-rv');
      io.observe(el);
    });
    root.classList.add('sf-rv-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
